import $ from 'jquery';
import {apiClient, setCookie} from "./api";
import {fetchMyProfile} from "./users";

export function setupLogin() {

    $('#log-in-form').on('submit', function(event) {
        event.preventDefault();

        const emailAddress = $('#emailAddress').val();
        const password = $('#password').val();

        apiClient('/api/log_in/',
            {
                method: 'POST',
                useToken: false,
                body: JSON.stringify({username: emailAddress, password: password}),
                headers: {
                    'Content-Type': 'application/json'
                }
            }, (responseData) => {
                setCookie('access_token', responseData.access, 1);
                setCookie('refresh_token', responseData.refresh, 14);
                // Store the access and refresh tokens in cookies
                fetchMyProfile();

            },
            (err) => {
                $('#message').text("Login failed. Please try again.");
            });
    });
}

export function setupForgotPassword() {
    $('#forgot-password-form').on('submit', function(event) {
        event.preventDefault();

        const emailAddress = $('#forgotEmailAddress').val();

        apiClient('/api/password_reset/',
            {
                method: 'POST',
                useToken: false,
                body: JSON.stringify({username: emailAddress}),
                headers: {
                    'Content-Type': 'application/json'
                }
            }, (responseData) => {
                // Redirect to the dashboard or reload the page
                // window.location.href = "/";
                $('#forgot-password-message').text("Password reset request succeeded.").show();
                $('#forgot-password-form').hide();

                console.log('Password reset requested successfully:', responseData);
            },
            (err) => {
                $('#forgot-password-message').text("Password reset failed. Please try again.");
                console.error('Error resetting password:', err);
            });
    });
}
